import { Box } from '@material-ui/core';
import { OnboardingDetailsRole, Role } from '@nemuru-eng/js-api-client';

import { Customer } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/entities/CheckoutSessionDetailEntity';
import { CheckoutSessionCustomerHistory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Customer/History/CheckoutSessionCustomerHistory';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useUserContext } from '@/contexts/UserContext/UserContext';

interface CustomerSummaryProps {
  customer: Customer | null;
  role?: OnboardingDetailsRole;
}

export const CustomerSummary = ({ customer, role = OnboardingDetailsRole.BORROWER }: CustomerSummaryProps) => {
  const { userEntity } = useUserContext();

  if (!customer) {
    return null;
  }

  const customerFullName = `${customer.fullName.firstName}${
    customer.fullName.lastName ? ` ${customer.fullName.lastName}` : ''
  }`;

  return (
    <>
      <FlexRow height={'30px'} width="100%">
        <Font variant="h5" color="title">
          <Text
            strong
            tId={
              role === OnboardingDetailsRole.BORROWER
                ? 'BORROWER'
                : role === OnboardingDetailsRole.CO_BORROWER
                ? 'CO_BORROWER'
                : 'GUARANTOR'
            }
          />
        </Font>
        {role === OnboardingDetailsRole.BORROWER &&
          !userEntity?.hasRole([Role.ROLE_IBC_TLMK_AGENT, Role.ROLE_IBC_TLMK_CHANNEL]) && (
            <CheckoutSessionCustomerHistory customer={customer} />
          )}
      </FlexRow>
      <FlexColumn pt={'4px'} gridGap={4} width="100%">
        <Box display="flex" width="100%">
          <Font variant="body2" color="textPrimary" className="overflow-text-ellipsis">
            <strong>{customerFullName}</strong>
          </Font>
        </Box>
        {customer.email && (
          <Box display="flex" width="100%">
            <Font variant="body2" color="textPrimary" className="overflow-text-ellipsis">
              {customer.email}
            </Font>
          </Box>
        )}
        {customer.phoneNumber && (
          <Font variant="body2" color="textPrimary" className="overflow-text-ellipsis">
            {customer.phoneNumber}
          </Font>
        )}
      </FlexColumn>
    </>
  );
};
